<template>
  <div class="pagenation-wrp">
    <template v-if="pageNation.count > 0">
      <div class="pagenation">
        <a :style="{visibility: !pageNation.isFirst ? 'visible' : 'hidden'}" @click="pageNation.clickFirst" class="pagenation-link first" role="button">最初</a>
        <a :style="{visibility: !pageNation.isFirst ? 'visible' : 'hidden'}" @click="pageNation.clickPrev" class="pagenation-link prev" role="button">前へ</a>
        <div class="pagenation-num">
          <FontawesomeIcon icon="angle-down" class="icn" />
          <select v-model.number="pageNation.currentPage">
            <option 
              v-for="page in pageNation.showNumber"
              :key="'page_' + page"
              :value="page"
            >{{ page }}</option>
          </select>
        </div>
        <a :style="{visibility: !pageNation.isEnd ? 'visible' : 'hidden'}" @click="pageNation.clickNext" class="pagenation-link next" role="button">次へ</a>
        <a :style="{visibility: !pageNation.isEnd ? 'visible' : 'hidden'}" @click="pageNation.clickEnd" class="pagenation-link last" role="button">最後</a>
      </div>
    </template>
  </div>
</template>

<script>
import { defineComponent, reactive, ref, computed } from '@vue/composition-api'
import * as logicPagenation from '@/logic/common/Pagenation'

export default defineComponent({
  props: {
    count: {
      type: Number,
      default: 0
    },
    per_page: {
      type: Number,
      default: 30
    },
    currentPage: {
      type: Number,
      default: 1
    },
    leftPage: {
      type: Number,
      default: 10
    },
    rightPage: {
      type: Number,
      default: 10
    }
  },
  setup (props, context) {

    const pageNation = logicPagenation.getPagenation(props, context)

    return {
      pageNation
    }
  }
})
</script>

<style lang="scss" scoped>
.pagenation {
  max-width: 400px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  background-color: #fff;
  border: 1px solid $color-line;
  border-radius: 6px;
  &-wrp {
    background-color: $color-bg-paper;
    padding: 20px 20px 100px;
    &.is-open {
      padding-bottom: 330px;
    }
  }
  &-link {
    display: flex;
    justify-content: center;
    align-items: center;
    color: $color-link;
    font-size: 1.4rem;
    height: 48px;
    flex: 0 1 50px;
    .icn {
      margin: 0 5px;
    }
    &.first,&.prev {
      border-right: 1px solid $color-line;
    }
    &.last,&.next {
      border-left: 1px solid $color-line;
    }
  }
  &-num {
    position: relative;
    flex: 1 1 0%;
    color: $color-link;
    text-align: center;
    select {
      color: $color-link;
      // margin-right: 10px;
      width: 100%;
      height: 48px;
      padding-left: 49%;
    }
    .icn {
      position: absolute;
      right: 12px;
      top: 50%;
      transform: translate3d(0,-50%,0);
      pointer-events: none;
    }
  }
  // .formparts.select {
  //   .select-label {
  //     justify-content: center;
  //     color: $color-link;
  //     border: none;
  //     padding: 0 10px;
  //     .icn {
  //       position: relative;
  //       top: auto;
  //       left: auto;
  //       transform: none;
  //       margin-left: 5px;
  //       color: #ccc;
  //       right: auto;
  //     }
  //   }
  //   .select-option-list {
  //     margin-bottom: 85px;
  //   }
  // }
}
</style>
